import { Card, CardContent } from "@mui/material";
import React from "react";

export interface BaseImageProps {
  width?: string;
  children: React.ReactNode;
}

export function BaseImage(props: BaseImageProps) {
  const { width, children } = props;

  return (
    <Card
      className="flex items-center justify-center rounded-none bg-zinc-200 overflow-visible"
      sx={{ width, height: "100%" }}
    >
      <CardContent className="flex p-0 max-w-full justify-center w-full" sx={{ height: "100%" }}>
        {children}
      </CardContent>
    </Card>
  );
}
